import styled from 'styled-components';

const legendHeight = 20;

export const DonutChartWidgetGraphStyled = styled.div`
  width: 100%;

  &[data-legend-hidden='true'] {
    height: 100%;
  }

  .am5-html-container {
    overflow: visible !important;

    & > div:first-child {
      z-index: 1;
    }
  }
`;

export const DonutChartWidgetLegendContainer = styled.div`
  width: 100%;
  height: ${legendHeight}px;
  overflow: scroll;

  &[data-operating-system='windows'] {
    overflow-y: hidden;
    overflow-x: hidden;
  }

  &[data-operating-system='windows']:hover {
    overflow-x: auto;
  }

  &[data-legend-hidden='true'] {
    height: 0;
  }

  .am5-html-container {
    overflow: visible !important;
  }
`;

export const DonutChartWidgetLegendStyled = styled.div`
  width: 100%;
  height: 100%;

  .am5-html-container {
    overflow: visible !important;
  }
`;

export const WidgetGraphContainerStyled = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;
  width: 100%;
  height: 100%;
`;
